// extracted by mini-css-extract-plugin
export default {"wrapper":"login_wrapper__RLF3d","form":"login_form__1NuBl","link":"login_link__IqnNU"};